<script>
  import router from "page"
  import Home from "./pages/Home.svelte"
  import About from "./pages/About.svelte"
  import Blog from "./pages/Blog.svelte"
  let params
  let page
  router('/', () => page = Home)
  router('/about', () => page = About)
  router('/blog/:id', (ctx, next) => {
  params = ctx.params
  next()}, () => (page = Blog))
  router.start()
</script>

<svelte:component this={page}  params="{params}"/>